import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Membership {
  tenantId: string;
  tenantName: string;
  role: string;
}

export interface CurrentUser {
  id: string;
  email: string;
  name: string;
  isPlatformAdmin?: boolean;
  memberships: Membership[];
}

interface AuthState {
  accessToken: string | null;
  user: CurrentUser | null;
  activeTenantId: string | null;
  setAccessToken: (t: string | null) => void;
  setUser: (u: CurrentUser | null) => void;
  setActiveTenantId: (id: string | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      user: null,
      activeTenantId: null,
      setAccessToken: (accessToken) => set({ accessToken }),
      setUser: (user) => {
        if (!user) {
          set({ user: null, activeTenantId: null });
          return;
        }
        const current = get().activeTenantId;
        const stillValid = current && user.memberships.some((m) => m.tenantId === current);
        const next = stillValid ? current : (user.memberships[0]?.tenantId ?? null);
        set({ user, activeTenantId: next });
      },
      setActiveTenantId: (activeTenantId) => set({ activeTenantId }),
      clear: () => set({ accessToken: null, user: null, activeTenantId: null }),
    }),
    {
      name: 'fact-auth',
      partialize: (s) => ({ activeTenantId: s.activeTenantId }),
    },
  ),
);
